<template>
  <div>
    <h1 class="custom-title-large text-center">
      Atendemos estes tipos de <span class="font-weight-black">empresas</span>
    </h1>
    <v-row class="py-8" align="start" justify="space-around">
      <v-col
        cols="5"
        sm="3"
        md="3"
        class="text-center d-flex flex-column align-center justify-start"
        v-for="(item, index) in services"
        :key="index"
      >
        <v-icon size="3rem" class="mb-2 d-flex" @click="changeStep()">
          {{ item.icon }}
        </v-icon>
        <span class="custom-normal-text text-blue">
          {{ item.text }}
        </span>
      </v-col>
    </v-row>
    <h1 class="custom-title-large text-center">e também... </h1>
    <v-row align="start" justify="space-around">
      <v-col
        cols="6"
        sm="4"
        md="4"
        class="text-center d-flex flex-column align-center justify-start"
      >
        <v-icon
          size="3rem"
          class="d-flex"
          color="#0080d1"
          @click="changeStep()"
        >
          person
        </v-icon>
        <span class="custom-normal-text text-blue">
          Profissionais autônomos e liberais
        </span>
      </v-col>
    </v-row>
    <div class="text-center mt-5">
      <p class="custom-normal-text text-green">
        Comece a simplificar a sua contabilidade agora mesmo!
      </p>
      <v-row justify="center" class="my-1">
        <v-col cols="12" sm="4" md="3">
          <v-btn
            @click="changeStep()"
            class="custom-btn-green rounded-0 btn-large"
          >
            Começar
          </v-btn>
        </v-col>
      </v-row>
      <router-link :to="'/login'" class="custom-text-link">
        Já tenho conta e quero acessar o Simplificador.
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: [
        {
          icon: '$simpleNational',
          text: 'MEIs e Empresas do Simples Nacional',
        },
        {
          icon: '$serviceProvider',
          text: 'Prestadores de serviço',
        },
        {
          icon: '$noEmployer',
          text: 'Sem funcionários registrados',
        },
      ],
    }
  },

  methods: {
    changeStep() {
      this.$emit('changeStep', 2)
    },
  },
}
</script>

<style module lang="scss">
@import '@design';
</style>
